<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="row mb-3" v-if="isEditAllowed">
                <div class="col-12">
                    <b-button variant="success" style="float:right" @click="showPopup">
                        <i class="fa fa-pencil mr-2" />Update Tableau Sources
                    </b-button>
                </div>
            </div>
            <div class="row" v-for="(src, index) in sources" :key="'sources-' + index">
                <div class="col-12">
                    <b-card>
                        <tableau-viz id='tableau-viz' :src="src.url" toolbar='bottom' />
                    </b-card>
                </div>
            </div>
        </div>

        <b-modal id="m-update-tableau" title="Update Tableau Sources" size="lg" centered no-close-on-backdrop
            no-close-on-esc hide-footer>
            <div v-for="(src, index) in sourcesUpdate" :key="'sources-update-' + index" class="mb-2">
                <b-input-group>
                    <b-form-input v-model="src.url" :key="'sources-update-input-' + index" />
                    <b-button variant="danger" class="ml-2" @click="deleteRow(src.id)">
                        <i class="fa fa-trash" />
                    </b-button>
                </b-input-group>
            </div>
            <b-row class="mt-3">
                <b-col md="6">
                    <!-- <b-button variant="dark" @click="addRow" :disabled="isSubmitting"> -->
                    <b-button variant="dark" @click="addRow">
                        <i class="fa fa-plus mr-2" />Tambah Source
                    </b-button>
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="primary" :disabled="isSubmitting" @click="submitSources">
                        <i class="fa fa-check mr-2" />Simpan
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script type='module'
    src='https://prod-apsoutheast-a.online.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js'></script>

<script>
import lodash from 'lodash'
export default {
    name: 'tableau',
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            isEditAllowed: false,

            sources: [],
            sourcesUpdate: [],
            lastId: 0

        }
    },
    methods: {

        init() {

            let getItems = this.$axios.get("tableau/get-all").then(res => {
                this.sources = res.data.data
                if(this.sources.length > 0){
                    console.log(this.sources[this.sources.length-1].id)
                    this.lastId = this.sources[this.sources.length-1].id
                }
                this.initStatus = 1
            })

        },

        addRow() {
            this.lastId += 1
            this.sourcesUpdate.push({'url': '', 'id': this.lastId})
        },

        deleteRow(id) {
            let index = this.sourcesUpdate.findIndex(o => o.id === id)
            this.sourcesUpdate.splice(index, 1)
        },

        submitSources() {
            this.isSubmitting = true
            let payload = this.sourcesUpdate

            this.$axios.post("tableau/update", payload).then(res => {

                this.$bvModal.hide("m-update-tableau")
                this.$helper.toastSuccess(this, "Source Tableau berhasil di-update!")
                this.init()

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        showPopup() {
            this.$bvModal.show('m-update-tableau')
            this.sourcesUpdate = lodash.cloneDeep(this.sources)
        },



    },
    created() {
        this.isEditAllowed = this.$helper.isAllowed(this.$helper.PERM_EDIT_TABLEAU)
        this.init()
    },
    beforeCreate() {
        let tableAu = document.createElement('script')
        tableAu.setAttribute('src', 'https://prod-apsoutheast-a.online.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js')
        tableAu.setAttribute('type', 'module')
        document.head.appendChild(tableAu)
    }
}
</script>
